/* eslint-disable prettier/prettier */
/* eslint-disable no-restricted-syntax */
import { all, takeLatest, put, select, call } from 'redux-saga/effects';
import api from 'services/api';

import { IState } from 'store';
import { INewTransportTypes } from './types';

import {
  addNewTransportRequest,
  addNewTransportSuccess,
  addNewTransportFailure,
} from './actions';

type INewTransportType = ReturnType<typeof addNewTransportRequest>;

export function* newTransportRequest({ payload }: INewTransportType) {
  try {
    const { data } = payload;

    const getMatricula = (state: IState) => state.user.current?.cdMatricula;
    const matricula: string = yield select(getMatricula);

    const formData = new FormData();

    formData.append('matricula', matricula);
    formData.append('tipoSolicitacao', 'Inclusão');
    formData.append('anexo', data.fileTransportVoucherFront ? data.fileTransportVoucherFront : '');
    formData.append('anexo', data.fileTransportVoucherBack ? data.fileTransportVoucherBack : '');
    formData.append('enderecoConfirmado', String(data.confirmedAddress));
    formData.append('chamadoEndereco', String(data.calledAddress));
    formData.append('unidadeConfirmada', String(data.unitConfirmed));
    formData.append('chamadoUnidade', String(data.calledUnit));
    formData.append('possuiVT', data.numberVT ? 'Sim' : 'Não')
    formData.append('numeroVT', String(data.numberVT));
    formData.append('itinerarioIda', JSON.stringify(data.itineraryGoing));
    formData.append('itinerarioVolta', JSON.stringify(data.itineraryBack));

    yield call(api.post, '/portal-conecta/vale-transporte', formData);

    const dataLayer = window.dataLayer || [];
    dataLayer.push({
      event: 'solicitationFormSubmitted',
      formName: `Transporte - Inclusão de VT`,
    });

    yield put(addNewTransportSuccess());
  } catch (err) {
    if (err && err?.response) {
      const response = {
        message: err.response?.data.message,
      };

      yield put(addNewTransportFailure(response));
      return;
    }

    yield put(
      addNewTransportFailure({
        message: 'Erro interno de servidor',
      }),
    );
  } finally {
    const { handleClickNextStep } = payload;
    handleClickNextStep();
  }
}

export default all([
  takeLatest(INewTransportTypes.NEW_TRANSPORT_REQUEST, newTransportRequest),
]);
